import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import Search from "../../../components/inputs/Search";
import { BasicContext } from "../../../App";
import LoadedRecords from "../../../components/LoadedRecords";
import ConfirmModal from "../../../components/modals/ConfirmModal";
import UserPayment from "../../../components/payments/UserPayment";

const TransactionsList = () => {
    const { t } = useTranslation();
    const { checkServerData, NOR, setAlerts } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [originalList, setOriginalList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showCancelPaymentModal, setShowCancelPaymentModal] = useState(false);
    const [search, setSearch] = useState("");
    const [displayNOR, setDisplayNOR] = useState(NOR);

    const getTransactionsList = async () => {
        const res = await postMethod("/payments-list");
        if (checkServerData(res)) {
            setList(res.data.list);
            setOriginalList(res.data.list);
        }
    };

    const handleSearch = (v) => {
        const searchedPhrase = v.toLowerCase();
        setSearch(searchedPhrase);
        if (searchedPhrase !== "") {
            let filterThisList = originalList;
            filterThisList = filterThisList.filter(
                (el) =>
                    el.order_number.toString().toLowerCase().includes(searchedPhrase) ||
                    el.pass_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.create_date.toString().toLowerCase().includes(searchedPhrase)
            );
            setList(filterThisList);
        } else {
            setList(originalList);
        }
    };

    const cancelPaymentForPass = async (up) => {
        const res = await postMethod("/cancel-payment-for-pass", { up: up });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "cancelled" }]);
            setLoading(true);
            setTimeout(() => {
                getTransactionsList();
            }, 200);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getTransactionsList();

        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">{t("loadingData")}</p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 my-4 my-lg-3 px-lg-2">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("transactions.transactions")}</h1>
                                <Button
                                    className="float-end d-inline-block me-2"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setLoading(true);
                                        getTransactionsList();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowsRotate} />
                                </Button>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-3 px-lg-2 mb-lg-0">
                                <Search value={search} onChange={(e) => handleSearch(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            {list.length > 0 ? (
                                <Fragment>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="px-lg-2 px-0">
                                        <Table className="white-table">
                                            <tbody>
                                                {list

                                                    .map((e, i) => (
                                                        <Fragment key={i}>
                                                            <UserPayment p={e} showActions onShowCancelPaymentModal={setShowCancelPaymentModal} checkPrivilege />
                                                        </Fragment>
                                                    ))
                                                    .slice(0, displayNOR)}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="text-center">
                                        {displayNOR >= list.length ? (
                                            <p className="opacity-4  mb-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                {t("loadMore")}
                                            </Button>
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}

            {showCancelPaymentModal && (
                <ConfirmModal
                    onClose={() => setShowCancelPaymentModal(false)}
                    show={true}
                    text={t("cancelPaymentModal.text", { passName: showCancelPaymentModal.pass_name, orderNumber: showCancelPaymentModal.order_number })}
                    proceedTxt={t("cancelPaymentModal.proceedTxt")}
                    cancelTxt={t("cancelPaymentModal.cancelTxt")}
                    onProceed={() => {
                        setShowCancelPaymentModal(false);
                        cancelPaymentForPass(showCancelPaymentModal);
                    }}
                    title={t("cancelPaymentModal.title")}
                />
            )}
        </Fragment>
    );
};

export default TransactionsList;
